import { hdocs } from './cliente.js';

/** A corporacao ja tem as tabelas do hdocs? Responde 200 mesmo enquanto o resto da API responde 503 (corporacao_em_preparo): e o que a tela de espera consulta. */
export const verPreparacao = () => hdocs({ url: '/preparacao' });

/* Entrada local de desenvolvimento -- 404 quando HDOCS_LOGIN_LOCAL e false. */
export const entrarLocal = ({ usuarioId, corp }) =>
    hdocs({ method: 'post', url: '/dev/login', body: { usuario_id: usuarioId, corp } });
